<template>
    <div class="w-100 h-100">
        <!-- MAPA -->

        <div
            id="map"
            class="z-0 fixed top-0 left-0 right-0 bottom-0 w-100 h-100"
        ></div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        establishments: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
    },

    watch: {
        keyword(keyword) {
            keyword
                ? (this.isResultsOpen = true)
                : (this.isResultsOpen = false);
        },
    },

    data() {
        return {
            map: null,
            options: {
                center: new google.maps.LatLng(
                    40.441975268699494,
                    -3.6990883886495918
                ),
                zoom: 7,
                disableDefaultUI: true,
                styles: [
                    {
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [{ visibility: "off" }],
                    },
                ],
            },
        };
    },

    mounted() {
        this.initMap();
    },

    methods: {
        initMap() {
            const map = document.getElementById("map");

            if (document.body.contains(map)) {
                map.style.zIndex = "0";
                this.map = new google.maps.Map(map, this.options);
            }

            this.markers();
        },

        markers() {
            this.establishments.forEach((establishment) => {
                const coordinates = establishment.coordinates.split(",");
                const marker = new google.maps.Marker({
                    title: establishment.name,
                    position: new google.maps.LatLng(
                        coordinates[0],
                        coordinates[1]
                    ),
                });

                marker.setIcon({
                    url: "/images/marker.png",
                    scaledSize: new google.maps.Size(50, 61),
                });

                marker.setMap(this.map);

                marker.addListener("click", () => {
                    this.setEstablishment(establishment);
                });
            });
        },

        setEstablishment(establishment) {
            this.establishment = Object.assign({}, establishment);

            this.findInMap(this.establishment);

            this.keyword = this.establishment.name;

            this.isResultsOpen = false;

            this.isPercentagesOpen = true;
        },

        findInMap(establishment) {
            const coordinates = establishment.coordinates.split(",");

            this.map.panTo(
                new google.maps.LatLng(coordinates[0], coordinates[1])
            );
        },

        trans(day) {
            const days = {
                MONDAY: "Lunes",
                TUESDAY: "Martes",
                WEDNESDAY: "Miércoles",
                THURSDAY: "Jueves",
                FRIDAY: "Viernes",
                SATURDAY: "Sábado",
                SUNDAY: "Domingo",
            };

            return days[day];
        },
    },
};
</script>
